import { Beaker, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";

export default function Treatment() {
  return (
    <section
      id="behandling"
      data-testid="section-treatment"
      className="bg-[#F7F5F0] py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <Reveal className="rounded-2xl bg-[#1A362B] text-[#F7F5F0] p-8 md:p-14 relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.05] bg-grain pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            <div className="lg:col-span-5">
              <div className="text-[11px] tracking-[0.22em] uppercase text-[#F7F5F0]/65">
                Behandling & garanti
              </div>
              <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-[44px] tracking-tight text-balance">
                Mekanisk behandling som{" "}
                <span className="text-[#C4A67B]">verkar över tid</span>
              </h2>
            </div>

            <div className="lg:col-span-7">
              <p className="text-[#F7F5F0]/80 leading-relaxed text-[15px] md:text-base">
                Vid fasadtvätt använder vi <span className="text-[#F7F5F0]">soft wash</span> — en skonsam metod där rengöringen
                appliceras med lågtrycksspruta istället för hårt högtryck. På tak och
                fasad arbetar vi även med mekanisk behandling och medel som
                motverkar påväxt av rötter, alger och svartbeläggningar. Behandlingen
                verkar stegvis över tid — synligt resultat kan utvecklas under{" "}
                <span className="text-[#F7F5F0]">6–24 månader</span> beroende på yta, skick och förutsättningar.
              </p>

              <div className="mt-8 grid sm:grid-cols-2 gap-4 md:gap-5">
                <div
                  data-testid="treatment-card-process"
                  className="bg-[#F7F5F0]/[0.04] border border-[#F7F5F0]/12 rounded-xl p-5 md:p-6"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#F7F5F0]/10 flex items-center justify-center">
                    <Beaker size={18} className="text-[#C4A67B]" strokeWidth={1.6} />
                  </div>
                  <div className="mt-5 font-serif-display text-lg leading-tight">
                    Mekanisk + behandlande
                  </div>
                  <p className="mt-2 text-[#F7F5F0]/65 text-sm leading-relaxed">
                    Vi kombinerar varsam mekanisk bearbetning med medel som
                    motverkar ny påväxt.
                  </p>
                </div>

                <div
                  data-testid="treatment-card-warranty"
                  className="bg-[#F7F5F0]/[0.04] border border-[#F7F5F0]/12 rounded-xl p-5 md:p-6"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#F7F5F0]/10 flex items-center justify-center">
                    <ShieldCheck size={18} className="text-[#C4A67B]" strokeWidth={1.6} />
                  </div>
                  <div className="mt-5 font-serif-display text-lg leading-tight">
                    4 års garanti
                  </div>
                  <p className="mt-2 text-[#F7F5F0]/65 text-sm leading-relaxed">
                    På utfört arbete lämnar vi 4 års garanti — för en trygg
                    långsiktig lösning.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
